import * as React from 'react';
import { FunctionComponent, PropsWithChildren } from 'react';

import { FormControl } from '@mui/material';

import BaseFormInputField from '../../../../../../shared/components/base-input-form-field/base-form-input-field';
import CharacterCounter from '../../../../../shared/components/ui/CharacterCounter/CharacterCounter';
import { descriptionMaxLength } from '../../../../../shared/utils/description-max-length.util';
import { BasicInfoComponentProps } from '../../types/basic-info-component.props';

export const CampaignDescriptionInput: FunctionComponent<
  BasicInfoComponentProps
> = (props: PropsWithChildren<BasicInfoComponentProps>) => {
  const { values, errors, touched, handleChange, handleBlur } = props;

  return (
    <FormControl data-testid="campaign-description-input-form-control">
      <BaseFormInputField
        id="description"
        label="Description"
        name="description"
        onBlur={handleBlur}
        onChange={handleChange}
        error={!!errors.description && touched.description}
        helperText={
          !!errors.description && touched.description && errors.description
        }
        value={values.description ?? ''}
        multiline={true}
        rows={9}
        inputProps={{
          maxLength: descriptionMaxLength,
        }}
        InputLabelProps={{ required: true }}
      />
      <CharacterCounter
        className="input-helper-text"
        current={values?.description?.length ?? 0}
        max={descriptionMaxLength}
      />
    </FormControl>
  );
};
